import { createAction } from 'redux-actions'
import { push } from 'react-router-redux'
import { ARTIST_PORTAL_ROUTE } from 'config'

// Global actions

export const clearArtist = createAction('CLEAR_PORTAL_ARTIST')
export const setIsAdmin = createAction('SET_ADMIN')
export const setAuthenticated = createAction('SET_ARTIST_AUTHENTICATED')
export const setCurrentArtistId = createAction('SET_CURRENT_ARTIST_ID')
export const setArtist = createAction('SET_ARTIST')
export const setPrimaryContact = createAction('SET_PRIMARY_CONTACT')
export const setUserDetails = createAction('SET_USER_DETAILS')

export function setAdminUserAndRedirect(token, artistId) {
  return function (dispatch) {
    dispatch(setAuthenticated({ token }))
    dispatch(setIsAdmin(true))
    dispatch(setCurrentArtistId(artistId))
    dispatch(push(ARTIST_PORTAL_ROUTE))
  }
}
